/* eslint-disable no-param-reassign */
export const changeParameterByName = (parameters, name, value) => {
  switch (name) {
    case 'qty1':
      parameters.quantities[0] = value;
      break;
    case 'qty2':
      parameters.quantities[1] = value;
      break
    case 'qty3':
      parameters.quantities[2] = value;
      break;
    case 'qty4':
      parameters.quantities[3] = value;
      break;
    default:
      parameters[name] = value;
      break;
  }
};

export default changeParameterByName;
